import { useEffect, useRef, useState } from 'react';
import HeaderLink from "./comp/HeaderLink"
import { Link, useHistory, useParams } from 'react-router-dom';
import { callService, niceCheck, niceCheckDecode } from '@Views/utils/ServiceUtils';
import { getParameterByName, isEmail, isEmpty, isNull, passwordCheck, sha256 } from "@Views/utils/StringUtils";
import ReactGa from 'react-ga4';

const Header = ({ getMsg, routesJson, userInfo, setUserInfo }: any) => {
  const msg = getMsg();
  const routesMsg = getMsg('routes');
  const headerRef: any = useRef(null);
  const history = useHistory();

  const params: any = useParams();
  const backUrl = params['pageUrl'] ? ('/' + params['pageUrl']) : '/';

  let win: any = window;

  let [selectAgePopupActive, setSelectAgePopupActive] = useState<boolean>(false);

  let [selectAge, setSelectAge] = useState<string>('A');

  const urlChange = async () => {
    await callService("OBMUE01U01");
  }

  const headerChange = (hash: string) => {
    const rootWrap = document.getElementById('root');

    if (rootWrap) {
      if (hash === '#/') {
        if (rootWrap['classList'].contains("wrap-main") === false) {
          rootWrap['classList'].add('wrap-main');
        }
      } else {
        if (rootWrap['classList'].contains("wrap-main")) {
          rootWrap['classList'].remove('wrap-main');
        }
      }

      const bgHashList = ['#/', '#/AuthKeyApply', '#/PasswordFind', '#/ServiceIntroduction', '#/ServiceUse/ServiceList', '#/ServiceUse/ServiceUseHow']
      if (hash.indexOf('#/Login') !== -1 || bgHashList.indexOf(hash) !== -1) {
        if (rootWrap['classList'].contains("wrap-edf3ff") === false) {
          rootWrap['classList'].add('wrap-edf3ff');
        }
      } else {
        if (rootWrap['classList'].contains("wrap-edf3ff")) {
          rootWrap['classList'].remove('wrap-edf3ff');
        }
      }

    }
  }

  const onMouseEnter = (e: any) => {
    if (headerRef['current']['classList'].contains("active") === false) {
      headerRef['current']['classList'].add('active');
    }
  }
  const onMouseLeave = (e: any) => {
    if (headerRef['current']['classList'].contains("active")) {
      headerRef['current']['classList'].remove('active');
    }
  }

  const logout = () => {

    const win: any = window;
    win.confirm(msg['header']['logoutMsg'], function () {
      OBMUE99R01();
      sessionStorage.removeItem('userInfo');
      setUserInfo();
    })

  }

  const OBMUE99R01 = async () => {
    return await callService("OBMUE99R01", userInfo);
  }

  const onClickRadioAge = (e: any) => {
    const selectedStdRadio: any = document.querySelector('input[name="radio-1"]:checked');
    setSelectAge(selectedStdRadio['value']);
  }

  const AuthKeyApplyClick1 = () => {

    if (userInfo) {
      history.push('/AuthKeyApply');
    }
    else {
      setSelectAgePopupActive(true);
    }

  }

  const AuthKeyApplyClick2 = () => {

    if (selectAge === 'A') {
      niceCheck('/api/#/AuthKeyApply');
    }
    else if (selectAge === 'B') {

    }

  }

  useEffect(() => {
    headerChange(window.location.hash);
    urlChange();
    return history.listen((location) => {
      if (window.location.href.indexOf('ecostest.bok.or.kr') === -1) {
        ReactGa.send({ hitType: 'pageview', path: location.pathname, location: location.pathname, title: location.pathname });
      }
      headerChange(window.location.hash);
      urlChange();
    })
  }, [history]);

  useEffect(() => {
    const encodeData: any = getParameterByName("EncodeData");
    if (isEmpty(encodeData) === false) {
      if (win.opener) {
        win.opener.location = win.location.href;
        win.opener.location.reload();
        win.close();
      }
    }
  }, []);

  return (
    <>
      <div className={"modal fade" + (selectAgePopupActive ? ' show' : '')}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <strong className="modal-title"></strong>
              <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { setSelectAgePopupActive(false) }}>
              </button>
            </div>
            <div className="modal-comp">
              <div className="txt-con">
                <div className="con-tit">
                  <strong className="tit">알림</strong>
                </div>
                <div className="con-desc">
                  <h4>이용자 구분 선택</h4>
                  <p><br /></p>
                  <div className="input-box">
                    <div className="input-group" style={{ textAlign: 'left', paddingLeft: '10px' }}>
                      <input type="radio" name="radio-1" id="radio-1" className="form-control" value="A" defaultChecked={true} onClick={onClickRadioAge} />
                      <label htmlFor="radio-1"><span>일반 이용자(만 14세 이상)</span></label>
                    </div>
                  </div>
                  <p><br /></p>
                  {selectAge === 'A' &&
                    <p>회원가입을 위한 본인인증 절차를 진행합니다.</p>
                  }
                </div>
                <div className="btn-wrap" style={{ "textAlign": "center" }}>
                  <div className="form-group form-group-checkbox">
                    <div className="input-box-group">
                      <div className="input-box">
                        <div className="input-group">
                          <button type="button" className="btn btn-popup positive" onClick={() => { AuthKeyApplyClick2() }}>확인</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"modal-backdrop fade" + (selectAgePopupActive ? ' show' : '')}></div>

      <div className="wrap-head">
        <div className="header" ref={headerRef}>
          <div className="depth2Bg" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}></div>
          <div className="header_innder clearfix">
            <div className="gnb_leftFixTit">
              <h1 className="logo_default">
                <Link className="logo_ecos" to='/' onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/') } }}>
                  <span className="gnbTit">
                    {msg['header']['title']}
                  </span>
                </Link>
              </h1>
            </div>

            <div className="gnbMenu" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onFocus={onMouseEnter}>
              <ul className="menu_list">
                <HeaderLink routesMsg={routesMsg} routesJson={routesJson} history={history} />
              </ul>
            </div>
            <div className="gnb_rightOptions">
              <ul className="gnbOptions">
                <li className="optionMenu partition-right">
                  <Link to='/' onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/') } }}>{msg['header']['home']}</Link>
                </li>
                {userInfo ?
                  <li>
                    <a className="optionMenu partition-right" onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { logout() } }} onClick={logout}>{msg['header']['logout']}</a>
                  </li>
                  :
                  <li className="optionMenu partition-right">
                    <Link to='/Login' onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/Login') } }}>{msg['header']['login']}</Link>
                  </li>
                }
                <li className="optionMenu">
                  <a onClick={AuthKeyApplyClick1} onKeyUp={(e) => { if (e['code'] === 'Space') { AuthKeyApplyClick1() } }}>{(userInfo ? msg['header']['authKeyApplyInfo'] : msg['header']['authKeyApply'])}</a>
                </li>
              </ul>
            </div>
          </div>


        </div>
      </div>
    </>
  );
}

export default Header;